import { render, staticRenderFns } from "./PinFilledIcon.vue?vue&type=template&id=151ed5cb&scoped=true&"
import script from "./PinFilledIcon.vue?vue&type=script&lang=ts&"
export * from "./PinFilledIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ed5cb",
  null
  
)

export default component.exports